import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import styles from './Progress.module.scss';

export enum Status {
    Hibernate = 'Hibernate', // no animation is running the bar is invisible
    Init = 'Init', //Preparing to potentially show the animation.
    Active = 'Active', //the animation is running slowly to 80%
    Complete = 'Complete', //the animation runs quickly to 100%
}

export interface ProgressProps {
    customClass?: string;
    status: Status;
}

const Progress = ({ customClass = '', status }: ProgressProps) => {
    const [statusClass, setStatusClass] = useState<string>();

    useEffect(() => {
        switch (status) {
            case Status.Complete:
                setStatusClass(styles.Complete);
                setTimeout(() => {
                    setStatusClass(styles.Hibernate);
                }, 1500);

                break;
            case Status.Active:
                setStatusClass(styles.Active);

                break;
            case Status.Init:
                setStatusClass(styles.Init);

                break;
            default:
                setStatusClass(styles.Hibernate);
        }
    }, [status]);

    return (
        <div className={classNames(styles.Progress, customClass, statusClass)}>
            <span className={styles.Loader}>&nbsp;</span>
        </div>
    );
};

export default Progress;
